import useStoreSelector from 'store/useStoreSelector';

function useDrawer() {
	const drawer = useStoreSelector((store) => store.drawer);

	return drawer;
}

export default useDrawer;
